export const requiredHospitalsApplyFormProps = [
    'name',
    'address',
    'city',
    'country',
    'contact_person',
    'phone_number',
    'email',
    'num_of_employees',
    'num_of_beds',
    'num_of_outpatients',
    'institution_level_id',
    'requested_support_description',
    'requested_support_reason',
    'requested_support_reason',
    'expert_work_expectations',
    'expected_project_outcome',
    'support_timeframe',
    'method_of_support',
    'confirm_support',
    'terms_and_conditions',
    'information_accuracy_confirmation'
];

export const requiredExpertsApplyFormProps = [
    'professional_resume_base64',
    'professional_endorsment_base64',
    'name',
    'surname',
    'institution',
    'phone',
    'email',
    'job_title',
    'country',
    'work_experience_range',
    'specialty_ids',
    'motivation',
    'regional_experience',
    'language_proficiency',
    'general_availability',
    'consent',
];

export const requiredTrainersApplyFormProps = ['name', 'surname', 'email', 'phone_number', 'country', 'field_of_expertise_ids'];

export const hospitalsApplyFormProps = {
    name: '',
    address: '',
    city: '',
    country: '',
    contact_person: '',
    phone_number: '',
    email: '',
    num_of_employees: null,
    num_of_beds: null,
    num_of_outpatients: null,
    institution_level_id: null,
    institution_level_other: null,
    institution_type_id: null,
    institution_type_other: null,
    field_of_expertise_ids: null,
    field_of_expertise_other: null,
    requested_support_description: '',
    requested_support_reason: '',
    requested_support_reason: '',
    expert_work_expectations: '',
    expected_project_outcome: '',
    support_timeframe: '',
    method_of_support: '',
    method_of_support_description: '',
    confirm_support: false,
    terms_and_conditions: false,
    information_accuracy_confirmation: false
};

export const expertsApplyFormProps = {
    name: '',
    surname: '',
    institution: '',
    phone: '',
    email: '',
    job_title: '',
    country: '',
    motivation: '',
    level_of_expertise_id: null,
    level_of_expertise_other: '',
    work_experience: null,
    work_experience_range: null,
    professional_resume_base64: null,
    professional_resume_base64_extension: null,
    professional_endorsment_base64: null,
    professional_endorsment_base64_extension: null,
    professional_society_membership: '',
    specialty_ids: [],
    specialty_other: '',
    specialty_surgery_subspecialty: '',
    regional_experience: [],
    regional_experience_countries: [],
    language_proficiency: [],
    language_proficiency_other: '',
    general_availability: '',
    general_availability_time: '',
    general_availability_other: '',
    consent: false,
    declaration_of_honour: false
};

export const trainersApplyFormProps = {
    name: '',
    surname: '',
    email: '',
    phone_number: '',
    country_origin: '',
    country_driveams: null,
    field_of_expertise_ids: null,
    language_proficiency: [],
    language_proficiency_other: '',
    is_escmid_course_completed: false,
    is_drive_ams_course_completed: false
};

export const availabilityValues = { onlineOnly: false, onsiteOnly: false, onlineOnsite: false, other: '' };

export const languageMarksValues = [{ value: 1, label: 'Basic' }, { value: 2, label: 'Intermediate' }, { value: 3, label: 'Expert' }, { value: 4, label: 'Native' }];

export const languagesValues = [
    { id: 1, value: 'English' },
    { id: 2, value: 'French' },
    { id: 3, value: 'German' },
    { id: 4, value: 'Russian' },
    { id: 5, value: 'Spanish' },
    { id: 6, value: 'Italian' },
    { id: 7, value: 'Arabic' },
    { id: 0, value: 'Other' },
];

export const proficienyValues = { English: 0, French: 0, German: 0, Russian: 0, Spanish: 0, Italian: 0, Other: 0 };

export const levelOfExpertiseValues = [{ id: 1, value: 'Specialist / clinical', }, { id: 2, value: 'Academic / non-clinical' }];

export const type = [
    {
        value: 1,
        label: 'Public'
    },
    {
        value: 2,
        label: 'Private, non-profit'
    },
    {
        value: 3,
        label: 'Private, for-profit'
    }
];


export const level = [
    { value: 1, label: 'Secondary' },
    { value: 2, label: 'Tertiary' },
    { value: 3, label: 'Academic' },
    { value: 4, label: 'Local' }
];

export const regionalExperienceValues = [
    {
        id: 1,
        value: 'Africa'
    },
    {
        id: 2,
        value: 'Eastern-Mediterranean region'
    },
    {
        id: 3,
        value: 'Europe'
    },
    {
        id: 4,
        value: 'South-East Asia'
    },
    {
        id: 5,
        value: 'Americas (PAHO)'
    },
    {
        id: 6,
        value: 'Western Pacific'
    }
];

export const registryRelatedExperienceValues = [
    // {
    //     id: 1,
    //     value: 'Infectious disease management'
    // },
    // {
    //     id: 2,
    //     value: 'Microbiology and diagnostics'
    // },
    // {
    //     id: 3,
    //     value: 'Infection prevention and control'
    // },
    // {
    //     id: 4,
    //     value: 'Antimicrobial Stewardship'
    // },
    // {
    //     id: 5,
    //     value: 'Implementation science and behavior change'
    // },
    {
        id: 6,
        value: 'Prevention and control'
    },
    {
        id: 7,
        value: 'Detection and diagnosis'
    },
    {
        id: 8,
        value: 'Treatment and management'
    },
    {
        id: 9,
        value: 'Surveillance and reporting'
    }
];

export const specialtyFieldsValues = [
    {
        id: 1,
        value: 'Infectious diseases management'
    },
    {
        id: 2,
        value: 'Clinical microbiology'
    },
    {
        id: 3,
        value: 'Infection control'
    },
    {
        id: 4,
        value: 'Intensive care'
    },
    {
        id: 5,
        value: 'Clinical pharmacy'
    },
    {
        id: 6,
        value: 'Pharmacology'
    },
    {
        id: 7,
        value: 'Nursing'
    },
    {
        id: 8,
        value: 'Pediatrics'
    },
    {
        id: 9,
        value: 'Pulmonology'
    },
    {
        id: 10,
        value: 'Surgery (please specify subspeciality):'
    }, //ОВА ДА СЕ ИСХЕНДЛА
    {
        id: 11,
        value: 'Internal medicine'
    },
    {
        id: 12,
        value: 'Laboratory – microbiology'
    },
    {
        id: 13,
        value: 'Laboratory – pathology'
    },
    {
        id: 14,
        value: 'Public health'
    },
    {
        id: 15,
        value: 'General/family medicine'
    },
    {
        id: 16,
        value: 'Veterinary sciences'
    },
    {
        id: 17,
        value: 'Implementation science'
    },
    {
        id: 18,
        value: 'Social sciences (anthropology, social care, etc.)'
    },
    {
        id: 19,
        value: 'Psychology'
    },
    {
        id: 20,
        value: 'Economics and related sciences'
    }
]

export const fieldsOfExpertise = [
    {
        value: 1,
        label: 'Infectious diseases management'
    },
    {
        value: 2,
        label: 'Clinical microbiology'
    },
    {
        value: 3,
        label: 'Diagnostic stewardship and laboratory services'
    },
    {
        value: 4,
        label: 'Infection prevention and control'
    },
    {
        value: 5,
        label: 'Antimicrobial Stewardship'
    }
];

export const yearsOfExperienceRange = [
    { id: 1, value: '< 5 years' },
    { id: 2, value: '5 – 10 years' },
    { id: 3, value: '10 – 15 years' },
    { id: 4, value: '15 – 20 years' },
    { id: 5, value: '20+ years' }
];

export const generalAvailabilityValues = [
    { id: 1, value: 'Online support only' },
    { id: 2, value: 'Online and onsite support' },
    { id: 3, value: 'Other, please specify:' }
];

export const whoRegionCountries = {
    "Africa": [
        "Algeria", "Angola", "Benin", "Botswana", "Burkina Faso", "Burundi", "Cameroon",
        "Cabo Verde", "Central African Republic", "Chad", "Comoros", "Congo", "Côte d'Ivoire",
        "Democratic Republic of the Congo", "Djibouti", "Egypt", "Equatorial Guinea",
        "Eritrea", "Eswatini", "Ethiopia", "Gabon", "Gambia", "Ghana", "Guinea",
        "Guinea-Bissau", "Kenya", "Lesotho", "Liberia", "Madagascar", "Malawi", "Mali",
        "Mauritania", "Mauritius", "Morocco", "Mozambique", "Namibia", "Niger", "Nigeria",
        "Rwanda", "Sao Tome and Principe", "Senegal", "Seychelles", "Sierra Leone",
        "Somalia", "South Africa", "South Sudan", "Sudan", "Tanzania", "Togo", "Uganda",
        "Zambia", "Zimbabwe"
    ],
    "Americas (PAHO)": [
        "Antigua and Barbuda", "Argentina", "Bahamas", "Barbados", "Belize", "Bolivia",
        "Brazil", "Canada", "Chile", "Colombia", "Costa Rica", "Cuba", "Dominica",
        "Dominican Republic", "Ecuador", "El Salvador", "Grenada", "Guatemala", "Guyana",
        "Haiti", "Honduras", "Jamaica", "Mexico", "Nicaragua", "Panama", "Paraguay",
        "Peru", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines",
        "Suriname", "Trinidad and Tobago", "United States", "Uruguay", "Venezuela"
    ],
    "South-East Asia": [
        "Bangladesh", "Bhutan", "India", "Indonesia", "North Korea",
        "Maldives", "Myanmar", "Nepal", "Sri Lanka", "Thailand", "Timor-Leste"
    ],
    "Europe": [
        "Albania", "Andorra", "Armenia", "Austria", "Azerbaijan", "Belarus", "Belgium",
        "Bosnia and Herzegovina", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark",
        "Estonia", "Finland", "France", "Georgia", "Germany", "Greece", "Hungary", "Iceland",
        "Ireland", "Israel", "Italy", "Kazakhstan", "Kyrgyzstan", "Latvia", "Lithuania",
        "Luxembourg", "Malta", "Moldova", "Monaco", "Montenegro", "Netherlands",
        "Macedonia", "Norway", "Poland", "Portugal", "Romania", "Russia", "San Marino",
        "Serbia", "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland", "Tajikistan",
        "Turkey", "Turkmenistan", "Ukraine", "United Kingdom", "Uzbekistan"
    ],
    "Eastern-Mediterranean region": [
        "Afghanistan", "Bahrain", "Djibouti", "Egypt", "Iran", "Iraq", "Jordan", "Kuwait",
        "Lebanon", "Libya", "Morocco", "Oman", "Pakistan", "Qatar", "Saudi Arabia",
        "Somalia", "Sudan", "Syria", "Tunisia", "United Arab Emirates", "Yemen"
    ],
    "Western Pacific": [
        "Australia", "Brunei", "Cambodia", "China", "Cook Islands", "Fiji", "Japan",
        "Kiribati", "Lao People's Democratic Republic", "Malaysia", "Marshall Islands",
        "Micronesia (Federated States of)", "Mongolia", "Nauru",
        "New Zealand", "Niue", "Palau", "Papua New Guinea", "Philippines",
        "Republic of Korea", "Samoa", "Singapore", "Solomon Islands", "Tonga", "Tuvalu",
        "Vanuatu", "Viet Nam"
    ]
};

export const supportTimeframeValues = [
    { id: 1, value: '0-3 months' },
    { id: 1, value: '3-6 months' },
    { id: 1, value: '6-12 months' },
    { id: 1, value: '12-18 months' }
]